import { createContext } from 'react';
import type { BANNERS_STORAGE_KEYS } from './helpers';

export const AppBannersContext = createContext<{
  displayTRIALBanner: boolean;
  displayBelgiumPeppolVerificationBanner: boolean;
  displayPeppolAccountantRegisteredBanner: boolean;
  displayPendingAccessRequestsBanner: boolean;
  dismissBanner: (dismissKey: BANNERS_STORAGE_KEYS) => void;
}>({} as any);
